import '~/styles/global.css'

import type { AppProps } from 'next/app'
import { lazy } from 'react'
import GoogleAnalytics from '../components/GoogleAnalytics'

export interface SharedPageProps {
  draftMode: boolean
  token: string
}

const PreviewProvider = lazy(() => import('~/components/PreviewProvider'))

// Install a global handler as early as possible so hydration/runtime errors
// still get reported even if React throws before effects run.
if (
  typeof window !== 'undefined' &&
  process.env.NEXT_PUBLIC_DEBUG_RUNTIME_ERRORS === 'true' &&
  !(window as any).__RKTIMBER_RUNTIME_DEBUG_INSTALLED
) {
  ;(window as any).__RKTIMBER_RUNTIME_DEBUG_INSTALLED = true
  window.addEventListener('error', (event) => {
    // eslint-disable-next-line no-console
    console.error('[runtime error]', {
      message: event.message,
      stack: (event.error as Error | undefined)?.stack,
    })
  })
}


export default function App({
  Component,
  pageProps,
}: AppProps<SharedPageProps>) {
  const { draftMode, token } = pageProps
  const enableLive =
    process.env.NEXT_PUBLIC_ENABLE_SANITY_LIVE === 'true' && process.env.NODE_ENV !== 'test'
  const enablePreview = draftMode && enableLive

  return (
    <>      
      <GoogleAnalytics GA_MEASUREMENT_ID={process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID} />
      {enablePreview ? (
        <PreviewProvider token={token}>
          <Component {...pageProps} />
        </PreviewProvider>
      ) : (
        <Component {...pageProps} />
      )}
    </>
  )
}
